import React from 'react';

import { useIntl, MessageDescriptor } from 'react-intl';

import { messages } from '../messages';
import { CODING_AGENT_IDS, CodingAgentId } from '../types';

// Static SVG imports for each agent logo
import claudeLogo from './assets/claude-logo.svg';
import codexLogo from './assets/codex-logo.svg';
import copilotLogo from './assets/copilot-logo.svg';
import cursorLogo from './assets/cursor-logo.svg';

const AGENT_LOGO: Record<CodingAgentId, string> = {
	[CODING_AGENT_IDS.githubCopilot]: copilotLogo,
	[CODING_AGENT_IDS.claude]: claudeLogo,
	[CODING_AGENT_IDS.cursor]: cursorLogo,
	[CODING_AGENT_IDS.codex]: codexLogo,
};

const AGENT_ALT_MESSAGE: Record<CodingAgentId, MessageDescriptor> = {
	[CODING_AGENT_IDS.githubCopilot]: messages.githubCopilotLogoAlt,
	[CODING_AGENT_IDS.claude]: messages.claudeLogoAlt,
	[CODING_AGENT_IDS.cursor]: messages.cursorLogoAlt,
	[CODING_AGENT_IDS.codex]: messages.codexLogoAlt,
};

export interface AgentAvatarProps {
	readonly agentId: CodingAgentId;
	/** Avatar size in pixels. Defaults to 24. */
	readonly size?: number;
}

export const AgentAvatar: React.FC<AgentAvatarProps> = ({ agentId, size = 24 }) => {
	const intl = useIntl();

	return (
		<img
			src={AGENT_LOGO[agentId]}
			alt={intl.formatMessage(AGENT_ALT_MESSAGE[agentId])}
			width={size}
			height={size}
			style={{ flexShrink: 0 }}
		/>
	);
};
